import { isPlatformBrowser, ViewportScroller } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Inject,
  Input,
  PLATFORM_ID
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AnalyticsService } from "../services/analytics/analytics.service";
import { LinkCheck } from "../services/link-check/link-check.service";
import { GlobalState } from "../store/global/global.reducer";
import { Observable } from "rxjs";
import {
  selectBaseHref,
  selectPageTitle
} from "../store/global/global.selectors";

@Directive({
  selector: "[dotcomFrontendWysiwyg]",
  standalone: true
})
export class WysiwygDirective implements AfterViewInit {
  @Input() wysiwygContainer: string | undefined;
  isBrowser = isPlatformBrowser(this.platformId);
  pageTitle$: Observable<string> = this.store.select(selectPageTitle);
  pageTitle = "";
  baseHref = "";
  baseHref$: Observable<string> = this.store.select(selectBaseHref);
  isExternalDomain = false;
  isFileLink = false;
  fileExtensions: string[] = [
    ".pdf",
    ".doc",
    ".docx",
    ".txt",
    ".xls",
    ".xlsx",
    ".ppt",
    ".pptx"
  ];

  constructor(
    private store: Store<{ global: GlobalState }>,
    public _elementRef: ElementRef,
    @Inject(PLATFORM_ID) private platformId: any,
    private cd: ChangeDetectorRef,
    private _analyticsService: AnalyticsService,
    private linkCheck: LinkCheck,
    private viewportScroller: ViewportScroller
  ) {
    this.pageTitle$.subscribe((title) => {
      this.pageTitle = title;
    });
    this.baseHref$.subscribe((baseHref) => {
      this.baseHref = baseHref;
    });
  }

  ngAfterViewInit() {
    const analyticsService = this._analyticsService;
    const pageTitle = this.pageTitle;
    const containerName = this.wysiwygContainer;

    if (this.isBrowser) {
      this.cd.detectChanges();
      const wysiwygLinkSelector =
        this._elementRef.nativeElement.querySelectorAll(
          ".wysiwyg a"
        ) as NodeListOf<HTMLElement>;
      wysiwygLinkSelector.forEach((element) => {
        const elementHref = element.getAttribute("href");

        this.isFileLink = this.fileExtensions.some((ext) =>
          elementHref?.endsWith(ext)
        );

        const strippedBaseHref = this.baseHref.replace("www.", "");
        const strippedUrl = elementHref?.replace("www.", "");

        this.isExternalDomain = !strippedUrl?.startsWith(strippedBaseHref);

        if (
          this.isExternalDomain ||
          this.isFileLink
        ) {
          element.setAttribute("target", "_blank");
        }

        if (elementHref && this.linkCheck.linkUnavailableCheck(elementHref)) {
          element.parentNode?.replaceChild(
            document.createTextNode(element.innerText),
            element
          );
        } else {
          element.addEventListener("click", (event) => {
            if (elementHref && elementHref.startsWith("#")) {
              event.preventDefault();
              this.viewportScroller.scrollToAnchor(
                elementHref.replace("#", "")
              );
            }
            analyticsService.adobeInteractionEvent(
              `WYSIWYG ${containerName}`,
              elementHref,
              element.innerHTML,
              "",
              "LinkClick",
              pageTitle,
              ""
            );
          });
        }
      });
    }
  }
}
